"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.responseCreatorBuilder = exports.or = exports.and = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var or = exports.or = function or() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }
  return function (body) {
    var errors = [];
    for (var i = 0; i < validators.length; i++) {
      var _context, _context2;
      var error = validators[i](body);
      if (!error) {
        return undefined;
      }
      errors = (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)(errors), [(0, _concat.default)(_context2 = "validator#".concat(i, ": ")).call(_context2, error.message)]);
    }
    return new Error(errors.join(', '));
  };
};
var and = exports.and = function and() {
  for (var _len2 = arguments.length, validators = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    validators[_key2] = arguments[_key2];
  }
  return function (body) {
    for (var i = 0; i < validators.length; i++) {
      var error = validators[i](body);
      if (error) {
        return error;
      }
    }
    return undefined;
  };
};
var responseCreatorBuilder = exports.responseCreatorBuilder = function responseCreatorBuilder(responseCreator, validators) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(response) {
      var responseError, body, _responseError;
      return _regenerator.default.wrap(function _callee$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(validators !== null && validators !== void 0 && validators.responseValidators)) {
              _context3.next = 5;
              break;
            }
            responseError = and.apply(void 0, (0, _toConsumableArray2.default)(validators.responseValidators))(response);
            if (!responseError) {
              _context3.next = 5;
              break;
            }
            responseError.message = "Response validation - ".concat(responseError.message);
            throw responseError;
          case 5:
            _context3.next = 7;
            return responseCreator(response.clone());
          case 7:
            body = _context3.sent;
            if (!(validators !== null && validators !== void 0 && validators.bodyValidators)) {
              _context3.next = 13;
              break;
            }
            _responseError = and.apply(void 0, (0, _toConsumableArray2.default)(validators.bodyValidators))(body);
            if (!_responseError) {
              _context3.next = 13;
              break;
            }
            _responseError.message = "Body validation - ".concat(_responseError.message);
            throw _responseError;
          case 13:
            return _context3.abrupt("return", body);
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
//# sourceMappingURL=responseBuilder.js.map